import { Box, Grid, Stack, Typography, useMediaQuery } from "@mui/material";
import { ResponsiveLine } from "@nivo/line";
import React from "react";
import { useSelector } from "react-redux";
import moment from "moment";

const PerformanceAnalysis = ({ time }) => {
  const statistics = useSelector((state) => state.statistics.item);

  const data7Days = statistics?.total_sales_last_7_days
    .slice()
    .sort((a, b) => {
      return new Date(a.date) - new Date(b.date);
    })
    .map((item) => ({
      x: moment(item.date).format("DD-MM-YYYY"),
      y: item.total_amount,
    }));

  const data7Weeks = statistics?.total_sales_last_7_weeks
    .slice()
    .sort((a, b) => {
      return new Date(a.date) - new Date(b.date);
    })
    .map((item, index) => ({
      x: `Week ${index + 1}`,
      y: item.total_amount,
    }));

  const data12Months = statistics?.total_sales_last_12_months
    .slice()
    .sort((a, b) => {
      return new Date(a.date) - new Date(b.date);
    })
    .map((item) => ({
      x: moment(item.date).format("MMMM"),
      y: item.total_amount,
    }));

  const data12Years = statistics?.total_sales_last_12_years
    .slice()
    .sort((a, b) => {
      return new Date(a.date) - new Date(b.date);
    })
    .map((item) => ({
      x: moment(item.date).year(),
      y: item.total_amount,
    }));

  const MyResponsiveLine = ({ data, yLeg }) => (
    <ResponsiveLine
      data={[
        {
          id: ".",
          color: "hsl(130, 70%, 50%)",
          data: data,
        },
      ]}
      margin={{ top: 50, right: 30, bottom: 50, left: 50 }}
      xScale={{ type: "point" }}
      yScale={{
        type: "linear",
        min: 0,
        max: "auto",
        stacked: true,
        reverse: false,
      }}
      yFormat=" >-.2f"
      axisTop={null}
      axisRight={null}
      axisBottom={{
        tickSize: 5,
        tickPadding: 5,
        tickRotation: 0,
        legend: yLeg,
        legendOffset: 36,
        legendPosition: "middle",
      }}
      axisLeft={{
        tickSize: 5,
        tickPadding: 5,
        tickRotation: 0,
        legend: "Total sales in Rs",
        legendOffset: -40,
        legendPosition: "middle",
      }}
      pointSize={10}
      pointColor={{ theme: "background" }}
      pointBorderWidth={2}
      pointBorderColor={{ from: "serieColor" }}
      pointLabelYOffset={-12}
      useMesh={true}
      legends={[
        {
          anchor: "bottom-right",
          direction: "column",
          justify: false,
          translateX: 100,
          translateY: 0,
          itemsSpacing: 0,
          itemDirection: "left-to-right",
          itemWidth: 80,
          itemHeight: 20,
          itemOpacity: 0.75,
          symbolSize: 12,
          symbolShape: "circle",
          symbolBorderColor: "rgba(0, 0, 0, .5)",
          effects: [
            {
              on: "hover",
              style: {
                itemBackground: "rgba(0, 0, 0, .03)",
                itemOpacity: 1,
              },
            },
          ],
        },
      ]}
    />
  );

  return (
    <Stack direction="column" marginTop={4} alignItems="center">
      <Typography
        variant="h4"
        color="text.secondary"
        sx={{ textDecoration: "underline" }}
      >
        Performance analysis
      </Typography>
      {(time === "today" || time === "all") && (
        <>
          <Box
            sx={{
              height: 400,
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {data7Days?.length ? (
              <MyResponsiveLine data={data7Days} yLeg="Active days" />
            ) : (
              "--"
            )}
          </Box>
          <Typography variant="h5" color="text.secondary" alignSelf="center">
            Last 7 days
          </Typography>
        </>
      )}
      {time === "week" && (
        <>
          <Box
            sx={{
              height: 400,
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {(data7Weeks?.length ?? 0) > 0 ? (
              <MyResponsiveLine data={data7Weeks} yLeg="Active weeks" />
            ) : (
              "--"
            )}
          </Box>
          <Typography variant="h5" color="text.secondary" alignSelf="center">
            Last 7 weeks
          </Typography>
        </>
      )}
      {time === "month" && (
        <>
          <Box
            sx={{
              height: 400,
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {data12Months?.length ? (
              <MyResponsiveLine data={data12Months} yLeg="Active months" />
            ) : (
              "--"
            )}
          </Box>
          <Typography variant="h5" color="text.secondary" alignSelf="center">
            Last 12 months
          </Typography>
        </>
      )}
      {(time === "year" ) && (
        <>
          <Box
            sx={{
              height: 400,
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {(data12Years?.length ?? 0) > 0 ? (
              <MyResponsiveLine data={data12Years} yLeg="Active years" />
            ) : (
              "--"
            )}
          </Box>
          <Typography variant="h5" color="text.secondary" alignSelf="center">
            Last 12 years
          </Typography>
        </>
      )}
    </Stack>
  );
};

export default PerformanceAnalysis;
